import { render } from "./BulkVoucherIssuanceList.vue?vue&type=template&id=bb846fe8&scoped=true"
import script from "./BulkVoucherIssuanceList.vue?vue&type=script&lang=js"
export * from "./BulkVoucherIssuanceList.vue?vue&type=script&lang=js"

import "./BulkVoucherIssuanceList.vue?vue&type=style&index=0&id=bb846fe8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb846fe8"]])

export default __exports__